import {css, view} from '@sail/ui/deprecated';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useEffect, useRef} from 'react';
import {Conversation} from '@stripe-internal/conversations-client';
import {useUniversalHelpDotComDesign} from '../../FeatureFlagsProvider';
import {useTheme} from '../../ThemeProvider';

const messages = defineMessages({
  linkAssistantGreeting: {
    id: 'conversations_ui.support_conversations_client.universal_help_client.linkAssistantGreeting',
    description:
      'Welcome message for Link and disclaimer about the Assistant and AI.',
    defaultMessage: 'Welcome to Link Support.',
  },
});

type Props = {
  conversation: Conversation;
};

export const ChatStartedRow = ({conversation}: Props) => {
  const useDotComDesign = useUniversalHelpDotComDesign();

  const {client} = conversation;
  const theme = useTheme();
  const isLinkAudience = theme.audience === 'link';
  const hasInitialQuery = Boolean(
    conversation.context?.triggerParams?.initialQuery,
  );

  const hasShownGreeting = client.hasShownInitialGreeting?.() || false;
  const initialShowGreeting = !hasShownGreeting && !hasInitialQuery;

  const showGreeting = useRef(initialShowGreeting);

  useEffect(() => {
    if (showGreeting.current) {
      client.markInitialGreetingAsShown?.();
    }
  }, [client]);

  if (useDotComDesign || !showGreeting.current || !isLinkAudience) {
    return null;
  }

  return (
    <view.div
      data-testid="chat-started-row"
      css={{
        // This is a little hacky, but there is always a message from
        // the backend below this. However, because they are two
        // separate messages they use the gap from the log items which
        // is too large for text.
        marginBottom: css.value('-8px'),
      }}
    >
      <view.div>
        <view.div
          css={{
            stack: 'x',
            alignX: 'start',
            alignY: 'center',
          }}
        >
          <view.div>
            <FormattedMessage {...messages.linkAssistantGreeting} />
          </view.div>
        </view.div>
      </view.div>
    </view.div>
  );
};
